export default "__VITE_ASSET__Da8Q95zx__"